import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/reducers';
import { NotificationsFilters } from '../../../commons/models/notifications';

@Component({
selector: 'app-notifications-filters',
templateUrl: './notifications-filters.component.html',
styleUrls: ['./notifications-filters.component.scss']
})
export class NotificationsFiltersComponent {
    @Output()
    onFilter: EventEmitter<NotificationsFilters> = new EventEmitter();

    private _defaultFilters: NotificationsFilters;
    filtersForm: FormGroup;

    constructor(private fb: FormBuilder, private store$: Store<AppState>) {
    this._createForm();

    }

    private _createForm() {
    let group = {
        title: '',
        onlyCurrentTenant: [true]
    }

    this.filtersForm = this.fb.group(group);
    }

    applyFilters() {
        this.onFilter.emit(this._getFilters());
    }

    private _getFilters(): NotificationsFilters {
    let filters: NotificationsFilters = {}
    if (this.filtersForm) {
        const values = this.filtersForm.value;
        if (values.title) {
        filters.title = values.title;
        }
        
        filters.onlyCurrentTenant = values.onlyCurrentTenant;
        
    }
    return filters;
    }


    resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
        title: '',
        onlyCurrentTenant: true

    });
    this._setDefaultValues();
    this.applyFilters();
    }

    get defaultFilters(): NotificationsFilters {
    return this._defaultFilters;
    }

    @Input()
    set defaultFilters(defaultFilters: NotificationsFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
    }

    private _setDefaultValues() {
        if (this.defaultFilters) {
            if (this.filtersForm) {
            this.filtersForm.patchValue({
                title: this.defaultFilters.title,
                onlyCurrentTenant: this.defaultFilters.onlyCurrentTenant
            })
            }
        }
    }
}